import { render, staticRenderFns } from "./BasicLayout.vue?vue&type=template&id=8bb1d494&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
import style0 from "./BasicLayout.vue?vue&type=style&index=0&id=8bb1d494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb1d494",
  null
  
)

export default component.exports